import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const resolvedBundleSchema = z.object({
  bundleId: z.string().uuid(),
});

export const templateBundleDefaultsContract = c.router(
  {
    resolveForAppointment: {
      method: 'GET',
      path: '/resolve/appointment/:appointmentId',
      pathParams: z.object({
        appointmentId: z.string().uuid(),
      }),
      responses: {
        200: resolvedBundleSchema,
        404: z.object({ message: z.string() }),
      },
      summary: 'Resolve the default template bundle for an appointment',
    },
  },
  {
    pathPrefix: '/:tenantId/template-bundle-defaults',
  },
);
